import http, { API_BASE } from './http';

export default {
  async list() {
    const response = await http.get(`${API_BASE}/api/exchange`);
    return response.data;
  },

  async create(exchangeData) {
    const response = await http.post(`${API_BASE}/api/exchange`, exchangeData);
    return response.data;
  },

  async lock(id, payload) {
    const response = await http.post(`${API_BASE}/api/exchanges/${id}/lock`, payload);
    return response.data; // handle envelope or raw
  },

  async update(id, updates) {
    const response = await http.put(`${API_BASE}/api/exchange/${id}`, updates);
    return response.data;
  },

  async delete(id) {
    await http.delete(`${API_BASE}/api/exchange/${id}`);
  },

  // Connect a real exchange (API key + secret). The owner is the JWT identity —
  // the backend ignores any client-supplied email, so none is sent.
  async addExchange({ exchange, name, apiKey, secretKey }) {
    const body = {
      exchange,
      name,
      API: apiKey,
      secret: secretKey,
    };
    return (await http.post(`${API_BASE}/api/add_exchange`, body)).data;
  },

  async updateKeys(exchangeId, { API_key, SECRET_key, apiKey, secretKey }) {
    const response = await http.post(`${API_BASE}/api/exchange/${exchangeId}/keys`, {
      API_key: API_key ?? apiKey,
      SECRET_key: SECRET_key ?? secretKey,
    });
    return response.data;
  },
};
